<ng-content select="kb-navigation-content"></ng-content> <!-- https://github.com/angular/angular/issues/50543 -->

<ng-template #breadcrumbItemTemplate [kbTemplateType]="breadcrumpsTemplateType" let-navigationItem="navigationItem" let-backLevels="backLevels">
  @if (navigationItem) {
    <ng-container [ngTemplateOutlet]="breadcrumbItemTemplate" [ngTemplateOutletContext]="{ navigationItem: navigationItem.parentItem, backLevels: backLevels+1 }"></ng-container>
  }
  <button type="button" tabindex="0" class="breadcrumb-item" [attr.back-levels]="backLevels">
    <kb-icon [icon]="iconBack" icon-uppercase icon-center class="nav-icon"></kb-icon> {{navigationItem ? navigationItem.label : intl.breadcrumbHomeLabel}}
  </button>
</ng-template>

<ng-template #navLevelTemplate [kbTemplateType]="navLevelTemplateType" let-navigationParentItem="navigationParentItem">
  <div class="nav-level kb-scrollbar">
    @if (navigationParentItem.label) {
      <div class="breadcrumbs">
        <ng-container [ngTemplateOutlet]="breadcrumbItemTemplate" [ngTemplateOutletContext]="{ navigationItem: navigationParentItem.parentItem, backLevels: 0 }"></ng-container>
      </div>
    }
    @if (navigationParentItem.contentId && navigationContentMap().has(navigationParentItem.contentId)) {
      <div class="nav-content">
        <ng-container [ngTemplateOutlet]="navigationContentMap().get(navigationParentItem.contentId)!"></ng-container>
      </div>
    }
    <ul class="nav-list kb-scrollbar">
      @if (navigationParentItem.href) {
        <li class="nav-item-container nav-item-overview-container" [class.active]="navigationParentItem.active === 'exact'">
          <a class="nav-item" [kbRouterOrExternalLink]="navigationParentItem.href" [attr.target]="navigationParentItem.target">
            {{intl.overviewMenuEntryPrefix}}
            {{navigationParentItem.label}}
          </a>
        </li>
      }
      @for (navigationItem of navigationParentItem.children; track (navigationItem.label + navigationItem.href + navigationItem.target + navigationItem.contentId)) {
        <li class="nav-item-container" [class.active]="navigationItem.active !== null">
          @if (navigationItem.href) {
            <a class="nav-item" [kbRouterOrExternalLink]="navigationItem.href" [attr.target]="navigationItem.target">
              {{navigationItem.label}}
              @if (navigationItem.children) {
                <kb-icon [icon]="iconSubMenu" icon-uppercase icon-center></kb-icon>
              }
            </a>
          } @else {
            <div class="nav-item"  tabindex="0">
              {{navigationItem.label}}
              @if (navigationItem.children) {
                <kb-icon [icon]="iconSubMenu" icon-uppercase icon-center></kb-icon>
              }
            </div>
          }
          @if (navigationItem.children) {
            <ng-container [ngTemplateOutlet]="navLevelTemplate" [ngTemplateOutletContext]="{ navigationParentItem: navigationItem }"></ng-container>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- Safari does not set focus on buttons... that's why we use a div instead -->
<div role="button" tabindex="0" class="mobile-overlay-button" [attr.aria-label]="intl.openNavigationButtonLabel">
  <kb-icon [icon]="iconMobileMenuClosed" icon-uppercase icon-center></kb-icon>
</div>
<ng-container [ngTemplateOutlet]="navLevelTemplate" [ngTemplateOutletContext]="{ navigationParentItem: { children: extendedNavigation } }"></ng-container>
